import styled from "styled-components";

export const SupplierStockTransitionBanner = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-size-3xs);
  align-items: center;
  padding: var(--spacing-size-3xs);
  box-sizing: border-box;
  border-radius: var(--border-radius-sm);
  background-color: var(--color-feedback-warning-100);

  & > clb-button::part(button):hover,
  & > clb-button::part(button):focus-visible {
    background-color: var(--color-feedback-warning-400);
    color: var(--color-neutral-600);
  }
`;

export const BannerContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--spacing-size-5xs);
  min-width: 0;
`;

export const BannerStatus = styled.output`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-size-5xs);
`;
